// extracted by mini-css-extract-plugin
export default {"ctn":"fade-in-image-effect_ctn__jwZas","image":"fade-in-image-effect_image__fBYW5"};